module.exports = __webpack_public_path__ + "img/112004.644f1d9d.png";